import Button from '~/components/Button.tsx';
import Icon from '~/components/Icon';
import { ICoupon } from '~kup/models/Coupon.ts';
import { useTranslation } from 'react-i18next';

export default function IssuableCouponsButton({
  issuableCoupons,
  onClick,
}: {
  issuableCoupons: ICoupon[];
  onClick: () => void;
}) {
  const { i18n } = useTranslation();

  return (
    <Button
      fullWidth
      size={'medium'}
      variant={'contained'}
      sx={() => ({
        color: 'white',
        fontWeight: 'bold',
        background: 'linear-gradient(to right, #A981FF, #379DFF)',
      })}
      onClick={() => {
        onClick();
      }}
    >
      <span
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {issuableCoupons.length > 1
          ? i18n.t('shop-product-get-coupons', { count: issuableCoupons.length })
          : i18n.t('shop-product-get-coupon')}
        <span
          style={{
            display: 'flex',
            width: '32px',
            height: '32px',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'black',
            background: 'white',
            borderRadius: '18px',
          }}
        >
          <Icon size={'22px'}>download</Icon>
        </span>
      </span>
    </Button>
  );
}
